export default __webpack_public_path__ + "static/media/ten_.d548d69d.jpeg";